import { convertCreditsFromServerToClient } from "../../../datastructures/Credits";
import { truncateString } from "../../../functions/Functions_General";
import { TournamentPlayer } from "../Interfaces_Tournament";

export class LeaderBoardUser {
  private parent: PIXI.Container;
  private userRankAndName: PIXI.Text;
  // private userNames: PIXI.Text;
  private userPoints: PIXI.Text;
  private userReWards: PIXI.Text;
  private userpointsIcons: PIXI.Sprite;
  private allInfos: Array<PIXI.Text | PIXI.Sprite>;
  private bg: PIXI.Graphics;
  private offsetleft: number;
  private rankingStyle: PIXI.TextStyle;
  // private prizeStyle: PIXI.TextStyle;
  constructor(
    parent: PIXI.Container,
    backgroundWidth: number,
    textStyle: PIXI.TextStyle,
    index: number
  ) {
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);
    this.rankingStyle = new PIXI.TextStyle({
      fontFamily: textStyle.fontFamily,
      fontSize: 33,
      fill: "#ffffff",
      // fontWeight:"bold",
      lineHeight: 33,

      align: "center",
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 2,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });
    // this.prizeStyle = new PIXI.TextStyle({
    //     fontFamily: textStyle.fontFamily,
    //     fontSize: 40,
    //     fill: "#ffffff",
    //     lineHeight: 50,  
    //     align: "center",
    //     dropShadow: true,
    //     dropShadowColor: "#000000",
    //     dropShadowBlur: 2,
    //     dropShadowAngle: Math.PI / 6,
    //     dropShadowDistance: 0,
    //   });
    // console.log(playerData)
    this.offsetleft = 120;
    let fontHeight = parseInt(textStyle.fontSize + "");
    this.bg = new PIXI.Graphics();
    this.bg.beginFill(0x28394e);
    this.bg.drawRoundedRect(
      0,
      0,
      backgroundWidth - this.offsetleft,
      fontHeight + 10,
      10
    );
    this.bg.endFill();
    this.bg.x = 25;
    this.bg.y = -10;
    this.parent.addChild(this.bg);
    this.bg.alpha = 0.55;

    this.userRankAndName = new PIXI.Text(index + ". ---", this.rankingStyle);
    this.userRankAndName.x = 40//100;
    this.userRankAndName.anchor.set(0, 0);
    this.userRankAndName.y=  this.bg.height/2-this.userRankAndName.height/2;
    this.parent.addChild(this.userRankAndName);

    //names

    // this.userNames = new PIXI.Text("", this.rankingStyle);
    // this.userNames.x = this.userRankAndName.x + 5+this.userNames.width;
    // this.userNames.y=   this.userRankAndName.y;
    // this.parent.addChild(this.userNames);
    //points

    this.userPoints = new PIXI.Text("", this.rankingStyle);
    this.userPoints.x = backgroundWidth - 390-50;
    this.userPoints.anchor.set(1, 0);
    this.userPoints.y=   this.userRankAndName.y;
    this.parent.addChild(this.userPoints);

    //points icons
    this.userpointsIcons = new PIXI.Sprite(
      PIXI.Texture.fromFrame("icon_points.png")
    );
    this.userpointsIcons.x = this.userPoints.x + 5;
    // this.userPoints.anchor.set(1,0);
    // this.userpointsIcons.y=   this.userRankAndName.y;
    this.parent.addChild(this.userpointsIcons);

    // if(textStyle.fill!='#ffffff')
    // {
    //     this.userpointsIcons.tint=0xff9900;
    // }

    //reward

    this.userReWards = new PIXI.Text("", this.rankingStyle);
    this.userReWards.x = backgroundWidth - this.offsetleft;
    this.userReWards.anchor.set(1, 0);
    this.userReWards.y=  this.userRankAndName.y; //this.bg.height/2-this.userReWards.height/2-20  // this.userRankAndName.y;
    this.parent.addChild(this.userReWards);
    // this.parent.x=100;
    ///--add to array
    this.allInfos = [
      this.userRankAndName,
      this.userPoints,
      this.userpointsIcons,
      this.userReWards,
    ];
    this.setNewScale(0.7);
    this.setEmpty();
    // this.tintColor(0xff0000)
  }

  public setEmpty = (): void => {
    // this.userRankAndName.text='---';
    // this.userNames.text = "---";
    this.userPoints.text = "---";
    this.userReWards.text = "---";
    // this.userNames.x = this.userRankAndName.x + 5+this.userNames.width;
    // this.userNames.text = truncateString("MY NAME IS LONG LONG LONG LONG",14);
    // this.userPoints.text = "999999";
    // this.userReWards.text =  truncateString("90000000 EUR + PLAYSTATION 50000",28);
    // this.userReWards.text = "90000000 EUR";

    // this.checkUserNameLength();
  };

  // private checkUserNameLength = (): void => {
  //   let uw = this.userNames.width;
  //   let maxLength = 270;
  //   if (uw > maxLength) {
  //     this.reduceString(maxLength);
  //   }
  // };
  // private reduceString = (maxLength: number): void => {
  //   this.userNames.text = this.userNames.text.slice(
  //     0,
  //     this.userNames.text.length - 1
  //   );
  //   if (this.userNames.width > maxLength) {
  //     this.reduceString(maxLength);
  //   } else {
  //     this.userNames.text = this.userNames.text + "..";
  //   }
  // };

  public setData(playerData: TournamentPlayer) {
    
    this.userRankAndName.text = playerData.position.toString() + ". "+ truncateString(playerData.displayName,10);

    this.userPoints.text = playerData.score.toFixed(2);
    //-old
    // this.userReWards.text=convertCreditsFromServerToClient(playerData.prize.monetaryPrize.amount).toFixed(2)+' '+playerData.prize.monetaryPrize.currency;

    //-new

    let casWin = convertCreditsFromServerToClient(
      playerData.prize.monetaryPrize.amount
    );

      

    let nonCashWin = playerData.prize.nonMonetaryPrize;

    if (nonCashWin != undefined) {

      if(playerData.prize.monetaryPrize.amount>0)
      {
        //--player won cash + item
        this.userReWards.text =
        
        truncateString(casWin.toFixed(2) +" " +(playerData.prize.monetaryPrize.currency) +' + ' +playerData.prize.nonMonetaryPrize,28);
        // this.userReWards.y= this.userRankAndName.y-16;//this.bg.height/2-this.userReWards.height/2-20  // this.userRankAndName.y;
      }
      else
      {
        this.userReWards.text =truncateString(playerData.prize.nonMonetaryPrize,28);
        // this.userReWards.y= this.userRankAndName.y-16;//this.bg.height/2-this.userReWards.height/2-20  // this.userRankAndName.y;
      }

      
    } else {
      this.userReWards.text =
      truncateString(casWin.toFixed(2) + ' ' + playerData.prize.monetaryPrize.currency,28);
        // this.userReWards.y=this.userRankAndName.y;
    }

    
    //--

    if (playerData.position <= 3) {
      this.tintColor(0xff9900);
    } else {
      this.tintColor(0xffffff);
    }
     //--//highlight the user
     if (playerData.isCurrentUserEntry) {
      this.tintColor(0x00ff00);
    }

    // this.checkUserNameLength();
  }

  private tintColor = (newColor: number): void => {
    this.userRankAndName.tint = newColor;
    this.userpointsIcons.tint = newColor;
    this.userPoints.tint = newColor;
    this.userReWards.tint = newColor;
  };

  public setNewScale = (newScale: number): void => {
    for (let i = 0; i < this.allInfos.length; i++) {
      this.allInfos[i].scale.set(newScale);
    }
  };
  public setPosY = (newPosY: number): void => {
    // for (let i = 0; i < this.allInfos.length; i++) {
    //     this.allInfos[i].y=newPosY;

    // }
    this.parent.y = newPosY;
  };
  public getHeight = (): number => {
    return this.bg.height;
  };
  public getPosY = (): number => {
    return this.parent.y;
  };

  public setVisible = (bool: boolean): void => {
    let alphaParent = bool ? 1 : 0;
    this.parent.alpha = alphaParent;
  };
}
